<template>
  <v-container>

    <v-row justify="center" class="align-center">
      <v-col class="text-center">
        <h2>Litt om oss</h2>
      </v-col>
      <v-col cols="12">

        <b>SiteSense startet som Sensorfabrikken i 2012</b> og var et firma som spesialiserte seg på å utvikle og levere ny sensorteknologi.<br/>
        I 2018 ble firmaet omdøpt til SiteSense og fokuset gikk videre til å ikke bare levere rene sensorløsninger, men også bruke ny innovative IoT løsninger for å monitorere og styre bygg samt generell automasjon.
        <br/><br/>


        Vi er i dag et teknologiselskap som som innehar bred kompetanse, blant annet innen design og utvikling av hardware- og software, automasjon og elektro.<br>
        Dette gjør oss i stand til å kunne levere det aller meste av sensor- og automasjonsløsninger samt programvare som etterspørres.
        <br/><br/>
        <b>Vi ønsker å være en rådgivende partner fra A til Å.</b><br>
        Ved å velge oss som partner, enten for eksisterende næringsbygg
        eller nybygg, vil vi kunne skape fremtidens miljø- og
        kostnadseffektive bygg sammen!
        <br>
        Med kostnadsfri kundeservice, brukervennlige systemer og
        fremtidsrettet AI, ønsker vi å være en miljøvennlig og
        kostnadsbesparende partner, for både næringsbygg og private.<br><br>
        <b>- Store muligheter – Lav inngangspris – lave løpende kostnader - Løsninger som betaler seg selv!</b>
      </v-col>

      <v-col class="text-center" cols="12" sm="6" md="2" v-for="(person, index) in persons" v-bind:key="'pers' + index">
          <v-img class="rounded mx-auto" width="128" height="128" :src="person.img"></v-img>

          <h3>{{person.name}}</h3>

          <h4>{{person.title}}</h4>

      </v-col>

    </v-row>
  </v-container>
</template>

<script>

export default {
  name: 'About-view',
  data: () => ({
    persons: [
      {name: 'Alf Solli',
        img: require('../assets/aboutus/Alf-Solli.png'),
        title: 'Hovedgrùnder og daglig leder'},

      {name: 'Per David Solli',
        img: require('../assets/aboutus/Per-David.jpg'),
        title: 'Systemutvikler'},

      {name: 'Karin Åsheim',
        img: require('../assets/aboutus/Karin.png'),
        title: 'Salg og markedsføring SiteSense sør'},

      {name: 'Bjarne Tveit',
        img: require('../assets/aboutus/Bjarne-Tveit.png'),
        title: 'Daglig leder SiteSense sør'},

      // {name: 'Henrik Hauglund',
      //   img: require('../assets/aboutus/Henrik-Hauglund.jpg'),
      //   title: 'Regionleder SiteSense sør'},

    ]

  }),
  mounted () {
    window.scrollTo(0, 0)
  },

}
</script>
